import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Star } from 'lucide-react';
import { shortTestimonials } from '../data/testimonials';
export function TestimonialsStrip() {
  const hasSamples = shortTestimonials.some(testimonial => testimonial.isSample);
  return <section className="py-12 bg-[#F5F7FB] border-y border-[#D89B16]/30" data-id="element-251" data-mp="3nzlj2eeeqgfe">
      <div className="max-w-7xl mx-auto px-4" data-id="element-252" data-mp="3nxihcx3w6yuu">
        <div className="text-center mb-7" data-id="element-253" data-mp="5l2pql71eaoy">
          <p className="text-[#081632] font-bold tracking-widest uppercase text-sm" data-id="element-254" data-mp="5jrey1f6c2oc">
            ⭐ What Judo Coaches Are Saying
          </p>
          {hasSamples && <p className="text-xs text-slate-500 mt-2" data-id="element-255" data-mp="fiqpjpji28dz">
              Sample reviews shown for layout — to be replaced with verified customer testimonials.
            </p>}
        </div>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-256" data-mp="2hc6g6mfl7n8y">
          {shortTestimonials.map((testimonial, index) => <motion.article key={testimonial.name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white border border-[#D89B16]/40 p-6 rounded-2xl shadow-sm shadow-[#1E4ED8]/10 flex flex-col" data-id="element-257" data-mp="2cdda3f2mqyit" data-mpi={index}>
              <div className="flex items-center justify-between gap-3 mb-4" data-id="element-258" data-mp="q66xr1elfty1">
                <div className="flex gap-1 text-[#D89B16]" aria-label="5 out of 5 stars" data-id="element-259" data-mp="v2p05umgbg77">
                  {[...Array(5)].map((_, starIndex) => <Star key={starIndex} size={16} fill="currentColor" data-id="element-260" data-mp="14454bkmoam2z" data-mpi={starIndex} />)}
                </div>
                {testimonial.isSample && <span className="text-[10px] font-bold uppercase tracking-wider text-[#1E4ED8] bg-[#1E4ED8]/10 px-2 py-0.5 rounded-full whitespace-nowrap" data-id="element-261" data-mp="1926t8m6s5fmd">
                    Sample Review
                  </span>}
              </div>
              <p className="text-slate-700 italic mb-6 text-sm leading-relaxed" data-id="element-262" data-mp="hz2zfiqg9y9l">“{testimonial.text}”</p>
              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-[#D89B16]/20" data-id="element-263" data-mp="d1ji29ygh5df">
                <div className="w-10 h-10 rounded-full bg-[#081632] flex items-center justify-center text-[#D89B16] font-bold text-sm shrink-0" aria-hidden="true" data-id="element-264" data-mp="r0sy99mnvzhe">
                  {getInitials(testimonial.name)}
                </div>
                <div className="min-w-0" data-id="element-265" data-mp="w05jxr1sr0ie">
                  <div className="font-bold text-[#081632] text-sm" data-id="element-266" data-mp="vzdr2nzl3gvt">{testimonial.name}</div>
                  <div className="text-xs text-[#1E4ED8] font-medium" data-id="element-267" data-mp="19qivs4ht6zd0">{testimonial.role}</div>
                  <div className="flex items-center gap-1 text-xs text-slate-500" data-id="element-268" data-mp="15pyy8ztbptqc">
                    <MapPin size={11} className="text-[#D89B16] shrink-0" data-id="element-269" data-mp="1jq9oc0mt74ag" />
                    {testimonial.location}
                  </div>
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}
function getInitials(name: string): string {
  return name.split(' ').map(part => part[0]).join('').slice(0, 2).toUpperCase();
}